import React from "react";
import "./css/tip_income_history.scss";

import NumberField from "../fields/number_field";
import TrainingTip from "../ui/training_tip";

/**
 * Fannie Mae tip-income guidance (Selling Guide B3-3.3-02). Shown as the blue
 * training-tip on the Tips line and used to drive the eligibility flag.
 */
/**
 * Standard training tip for the Bonus and Commission lines (Randy's wording).
 */
export const BONUS_COMMISSION_TIP =
  "Underwriting Guidelines may be different for Lenders. Please check with your " +
  "lender. If the Current year is higher, we use the current year's Commissions " +
  "and Bonus. If last year's Commissions and Bonus were a higher amount, and " +
  "because the current year was declining, then the 2 year average would be " +
  "what we export to the LOS. Some lenders because of their Credit overlays for " +
  "underwriting may Not take the Average but the lower amount for the current " +
  "year. A LOE may be required by your lender for the income drop. Talk with an " +
  "Underwriter to see what they will accept for income.";

export const TIP_INCOME_TIP =
  "LANIS Training Tip: Fannie Mae Selling Guide B3-3.3-02 — a minimum 2-year " +
  "history of tip income is recommended, but income received for no less than " +
  "12 months may be acceptable if there are positive factors to reasonably " +
  "offset the shorter history. Under 12 months cannot be used. Average the " +
  "year-to-date plus the prior year(s) over the months documented. " +
  "Documentation: most recent paystub, 2 years W-2s, and Form 1005 VOE (or 2 " +
  "years of personal tax returns with IRS Form 4137), plus a verbal VOE. " +
  "FHA / VA / USDA and lender overlays can differ.";

/**
 * "Months of Tip Income History" input + the red / amber / green eligibility
 * flag. Rendered under the Tips line in every income calculator that has tips.
 * The flag only appears once tip income has been entered.
 */
export default function TipIncomeHistory({ incomeSource, onChangeIncome }) {
  const months = parseInt(incomeSource.tips_history_months || "0", 10) || 0;
  const tips0 = parseFloat(incomeSource.tips_0 || "0") || 0;
  const tips1 = parseFloat(incomeSource.tips_1 || "0") || 0;
  const hasTips = tips0 > 0 || tips1 > 0;

  let flagClass = "";
  let flagText = "";
  if (hasTips) {
    if (months < 12) {
      flagClass = "tip-flag-red";
      flagText = "Not eligible — Fannie Mae requires a 12-month minimum.";
    } else if (months < 24) {
      flagClass = "tip-flag-amber";
      flagText =
        "Allowed only with positive compensating factors (FNMA B3-3.3-02).";
    } else {
      flagClass = "tip-flag-green";
      flagText = "Standard — 2+ year tip history.";
    }
  }

  return (
    <div className="tip-income-history">
      <label className="tip-history-months">
        Months of Tip Income History
        <NumberField
          fieldName="tips_history_months"
          value={incomeSource.tips_history_months || "0"}
          onChange={onChangeIncome}
        />
      </label>
      {flagText && <div className={`tip-flag ${flagClass}`}>{flagText}</div>}
    </div>
  );
}
